<template>
  <component
    :is="url ? UiSmartLink : 'div'"
    :to="url"
    :class="['pill-container', type]"
  >
    <div v-if="prefixItem" class="prefix-item">
      <component
        v-if="'is' in prefixItem"
        :is="prefixItem.is"
        v-bind="prefixItem"
      />
    </div>
    <div class="content">
      {{ text }}
    </div>
    <div v-if="suffixItem" class="suffix-item">
      <component
        v-if="'is' in suffixItem"
        :is="suffixItem.is"
        v-bind="suffixItem"
      />
    </div>
  </component>
</template>

<script lang="ts" setup>
import type { PillProps } from './types'
import UiBadgeCounter from '@sephora-asia/ui-badge-counter/UiBadgeCounter.vue'
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'
import UiSmartLink from '@sephora-asia/ui-smart-link/UiSmartLink.vue'
import { computed } from 'vue'

const props = defineProps<PillProps>()

function defaultComponent(
  props: PillProps,
  type: 'prefixComponent' | 'suffixComponent'
) {
  const componentProps = props[type]
  if (componentProps?.component === 'badge-counter') {
    return {
      is: UiBadgeCounter,
      size: '16px',
    }
  }

  if (componentProps?.component === 'icon') {
    return {
      is: UiIcon,
      size: '16px',
      isClickable: props.url ? true : false,
      colorFill:
        props.type === 'tertiary'
          ? 'var(--color-base-white)'
          : 'var(--color-base-black)',
    }
  }
}

const prefixItem = computed(() => {
  return {
    ...defaultComponent(props, 'prefixComponent'),
    ...props.prefixComponent,
  }
})

const suffixItem = computed(() => {
  return {
    ...defaultComponent(props, 'suffixComponent'),
    ...props.suffixComponent,
  }
})
</script>

<style lang="scss" scoped>
.pill-container {
  @extend .body-m;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 0.25rem;
  height: 32px;
  padding: 0px 12px;
  border-radius: 24px;
  color: var(--color-base-black);
  text-decoration: none;

  &.primary {
    background-color: var(--color-base-grey-05);
  }

  &.secondary {
    border: 1px solid var(--color-base-black);
    background-color: var(--color-base-white);
  }

  &.tertiary {
    background-color: var(--color-base-red-100);
    color: var(--color-base-white);
  }

  .prefix-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .suffix-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
